import { DashboardProject } from "@api/apiClient";
import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import DashboardTileCard from "./DashboardTileCard";

interface DashboardTilesProps {
  data: DashboardProject[];
  selectedProjects: string[];
  onSelectionChange: (newSelection: string[]) => void;
  isSelectionLimitReached: boolean;
  enableSelection?: boolean;
}

const DashboardTiles = observer((props: DashboardTilesProps) => {
  const navigate = useNavigate();
  const { data, selectedProjects, onSelectionChange, isSelectionLimitReached, enableSelection = true } = props;

  const handleSelectionToggle = (projectId: string, selected: boolean) => {
    if (selected) {
      // Add to selection
      onSelectionChange([...selectedProjects, projectId]);
    } else {
      // Remove from selection
      onSelectionChange(selectedProjects.filter(id => id !== projectId));
    }
  };

  const handleNavigate = (projectId: string) => {
    navigate(`/projects/${projectId}`);
  };

  return (
    <Grid mt={2} container spacing={2}>
      {data?.map((project: DashboardProject) => {
        const isSelected = selectedProjects.includes(project.projectId!);
        // Disable selection for unselected cards when limit is reached
        const isSelectionDisabled = !isSelected && isSelectionLimitReached;
        
        return (
          <Grid key={project.projectId}>
            <DashboardTileCard
              project={project}
              isSelected={isSelected}
              onSelectionChange={handleSelectionToggle}
              onNavigate={handleNavigate}
              isSelectionDisabled={isSelectionDisabled}
              enableSelection={enableSelection}
            />
          </Grid>
        );
      })}
    </Grid>
  );
});

export default DashboardTiles;
